import "./EditHours.scss";

export default function EditHours() {
  return (
    <section className="sales-layout__page edit-hours">
      <h1>Stunden bearbeiten</h1>
      <p>Hier werden zukünftig die Stunden bearbeitet.</p>
    </section>
  );
}
